import React from 'react'
import { Box, HStack, Image, Text } from '@chakra-ui/react'

export type CardFaqsProps = {
  name: string
  body: string
  image?: string
  noOfLinesName?: number
  noOfLinesBody?: number
  slug?: string
  onClick?: (slug: string) => void
}

export const CardFaqs = ({
  name,
  body,
  image,
  noOfLinesName,
  noOfLinesBody,
  onClick,
  slug = '',
  ...props
}: CardFaqsProps) => (
  <HStack
    userSelect={'none'}
    display={'flex'}
    gap={2}
    paddingY={6}
    borderBottomWidth={2}
    borderBottomColor={'#202020'}
    cursor={'pointer'}
    _hover={{ opacity: 1 }}
    _active={{ opacity: 0.8 }}
    opacity={0.9}
    onClick={() => onClick && onClick(slug)}
    {...props}
  >
    {!!image && (
      <Image
        src={image}
        objectFit={'cover'}
        width={'55px'}
        height={'55px'}
        borderRadius={14}
      />
    )}
    <Box>
      <Text noOfLines={noOfLinesName || 1} fontSize={'sm'} lineHeight={1.8}>
        {name}
      </Text>
      <Text
        noOfLines={noOfLinesBody || 2}
        fontSize={'xs'}
        lineHeight={1.5}
        color={'#a2a2a2'}
      >
        {body}
      </Text>
    </Box>
  </HStack>
)
